import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { SubdivisionService } from '../subdivision.service';
import { ContactsService } from 'src/app/contacts/contacts.service';
import { City } from '../../cities/city'
import { Subdivision } from '../subdivision';
import { Observable, empty } from 'rxjs';
import { map, debounceTime, finalize, switchMap, tap, startWith, filter } from 'rxjs/operators';
import { API, APIDefinition, Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { Contact } from '../../contacts/contact';
import { faEdit, faTrashAlt, faCopy } from '@fortawesome/free-solid-svg-icons';
import { MatAutocomplete, MatChipInputEvent, MatRipple } from '@angular/material';
import { RippleService } from '../../utils/ripple.service';
import { Customer } from '../../customers/customers';
import { GridDeleteComponent } from '../../utils/grid-delete-component';
import { AuthService } from '../../auth.service';
import { LoggingService } from '../../utils/logging.service';
import { GlobalEmailService } from '../../utils/globalemail.service';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { io } from 'socket.io-client';
import { environment } from '../../../environments/environment';
import { TagService } from 'src/app/utils/tags.service';
import { COMMA, ENTER, U } from '@angular/cdk/keycodes';
import { EmployeeService } from 'src/app/employee/employee.service';
import { LocationService } from 'src/app/location/location.service';
import { CityService } from 'src/app/cities/cities.service';
import { _DROPDOWN_US_STATES, _DROPDOWN_PATHWAYS, _DROPDOWN_STORY_TYPES, SCOPE_CATEGORIES, SCOPE_CATEGORY_MF, MF_PROJECT_SYNC_TAG_IDS } from 'src/app/utils/constants';
import { MfContactsDialogComponent } from './mf-contacts-dialog.component';


export interface Region {
  value: string;
  viewValue: string;
}

export interface State {
  value: string;
  viewValue: string;
}

export interface Consultant {
  value: number;
  viewValue: string;
}

export interface SubdivisionDialogData {
  updateall: boolean;
  townhomes: boolean;
  contact_id: number;
  subdivision_id: number;
  subdivision_name: string;
  city: string;
  state: string;
  cz: string;
  gps: string;
  inactivesubdivision: boolean;
  dzip: string;
  lat: string;
  lng: string;
  dhvaccontractor: number;
  region: string;
  ratercompid: number;
  jurisdictionid: number;
  weatherloc: string;
  scope: string;
  elevation: number;
  priceadder: number;
  municipality: string;
  areamanager: string;
  areamanemail: string;
  archive: boolean;
  gasutility: string;
  elecutility: string;
  mode: number;
  loggedIn : any;
  customer_id: number;
  customer_name: string;
  overridesc: boolean;
  generator: boolean;
  s_tags: any[];
  consultant: number;
  contact: string;
  bldr_region: string;
  ismultifamily : boolean;
  num_units: number;
  story_type: string;
  sub_id: number;
  sub_name: string;
  // Second and third informational scopes + the pathways under each scope (many per scope).
  scope2: string;
  scope3: string;
  scope1paths: string[];
  scope2paths: string[];
  scope3paths: string[];
  stickerlocation: string;
  envspecs: string;
  isbillingbldg: boolean;
  mf_contacts?: any[];

}


@Component({
  selector: 'app-edit-subdivision-dialog',
  templateUrl: 'edit-subdivision-dialog.html'
})
export class EditSubdivisionDialogComponent implements OnInit {
  customer$: any;
  builder$: any;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  updateAce: boolean = false;
  employee_name: any;
  employee$: any;
  contact$: Observable<any[]>;
  hvacDisplay: string;
  gasUtilities: any;
  elecUtilities: any;


  constructor(public dialogRef: MatDialogRef<EditSubdivisionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: SubdivisionDialogData,
              private fb: FormBuilder, public subdivisionService: SubdivisionService, public rippleService: RippleService, public log: LoggingService,
              public ges: GlobalEmailService, private messager: MessagerComponent, public contactService: ContactsService, public tagService: TagService,
              public employeeService: EmployeeService, public cityService: CityService, public locationService: LocationService, public dialog: MatDialog ) {}

  @ViewChild('cityRipple',{ read: MatRipple})
  cityRipple: MatRipple;
  @ViewChild('regionRipple', { read: MatRipple})
  regionRipple: MatRipple;
  @ViewChild('stateRipple', { read: MatRipple})
  stateRipple: MatRipple;
  @ViewChild('elevationRipple', { read: MatRipple})
  elevationRipple: MatRipple;
  @ViewChild('defaultczRipple', { read: MatRipple})
  defaultczRipple: MatRipple;
  @ViewChild('cityname', { read: false, static: false})
  cityNameInputRef: ElementRef;
  viewedCity = new FormControl();

    subdivisionForm = new FormGroup({
      subdivision_name: new FormControl(this.data.subdivision_name || ''),
      city: new FormControl(this.data.city || ''),
      state: new FormControl(this.data.state || ''),
      cz: new FormControl(this.data.cz || ''),
      gps: new FormControl(this.data.gps || ''),
      inactivesubdivision: new FormControl(this.data.inactivesubdivision || ''),
      dzip: new FormControl(this.data.dzip || ''),
      lat: new FormControl(this.data.lat || ''),
      lng: new FormControl(this.data.lng || ''),
      dhvaccontractor: new FormControl(this.data.dhvaccontractor || 0),
      region: new FormControl(this.data.region?.trim() || ''),
      ratercompid: new FormControl(this.data.ratercompid || 0),
      jurisdictionid: new FormControl(this.data.jurisdictionid || 0),
      weatherloc: new FormControl(this.data.weatherloc || ''),
      scope: new FormControl(this.data.scope || ''),
      // Second and third informational scopes + the pathways under each scope. Each
      // scope's pathways are a FormArray of selects the user adds to with a "+" button.
      scope2: new FormControl(this.data.scope2 || ''),
      scope3: new FormControl(this.data.scope3 || ''),
      scope1paths: new FormArray((this.data.scope1paths || []).map(p => new FormControl(p))),
      scope2paths: new FormArray((this.data.scope2paths || []).map(p => new FormControl(p))),
      scope3paths: new FormArray((this.data.scope3paths || []).map(p => new FormControl(p))),
      elevation: new FormControl(this.data.elevation || 0),
      priceadder: new FormControl(this.data.priceadder || 0),
      municipality: new FormControl(this.data.municipality || ''),
      areamanager: new FormControl(this.data.areamanager || ''),
      areamanemail: new FormControl(this.data.areamanemail || ''),
      archive: new FormControl(this.data.archive || false),
      gasutility: new FormControl(this.data.gasutility?.trim() || ''),
      elecutility: new FormControl(this.data.elecutility?.trim() || ''),
      customer_id: new FormControl(this.data.customer_id || 0),
      customer_name: new FormControl(this.data.customer_name || ''),
      overridesc: new FormControl(this.data.overridesc || false),
      townhomes: new FormControl(this.data.townhomes || false),
      generator: new FormControl(this.data.generator || false),
      tagControl: new FormControl(),
      consultant: new FormControl(this.data.consultant || 0),
      contact_id: new FormControl(this.data.contact_id || 0),
      contact : new FormControl(this.data.contact || ''),
      sub_id : new FormControl(this.data.sub_id || null),
      // Denormalized copy of the selected sub's name, kept in sync by onSelectSub.
      // Not rendered - it exists so the row is readable without a join (same as customer_name/contact).
      sub_name : new FormControl(this.data.sub_name || ''),
      updateall : new FormControl(this.data.updateall || false),
      bldr_region: new FormControl(this.data.bldr_region || ''),
      ismultifamily : new FormControl(this.data.ismultifamily || false),
      num_units : new FormControl(this.data.num_units || null),
      story_type : new FormControl(this.data.story_type || ''),
      stickerlocation : new FormControl(this.data.stickerlocation || ''),
      envspecs : new FormControl(this.data.envspecs || ''),
      isbillingbldg : new FormControl(this.data.isbillingbldg || false),
    });

    mode = this.data.mode;
    mfContactCount = (this.data.mf_contacts || []).length;
    get mfContactsLabel(): string { return this.mfContactCount > 0 ? 'View/Edit MF Contacts' : 'Add MF Contacts'; }
    city$: Observable<City[]>;
    isLoading = false;
    tags: any[] = [];
    inputTags: any[] = [];
    filteredTags: Observable<any[]>;

    // MF / SF / GPS tag-type filter. Empty = show all.
    tagTypeFilter: string[] = [];
    get visibleTags(): any[] { return this.tagService.filterByTypes(this.tags, this.tagTypeFilter); }
    toggleTagType(t: string): void {
      this.tagService.toggleType(this.tagTypeFilter, t);
      const c = this.subdivisionForm.get('tagControl');
      if (c && c.value) { c.setValue(c.value); }
    }

    scopes: any[] = [];

    pathways: string[] = _DROPDOWN_PATHWAYS;
    storyTypes: string[] = _DROPDOWN_STORY_TYPES;

    // Each scope's pathways are a FormArray of pathway selects (many per scope).
    get scope1pathsArray(): FormArray { return this.subdivisionForm.get('scope1paths') as FormArray; }
    get scope2pathsArray(): FormArray { return this.subdivisionForm.get('scope2paths') as FormArray; }
    get scope3pathsArray(): FormArray { return this.subdivisionForm.get('scope3paths') as FormArray; }
    addPathway(which: 'scope1paths' | 'scope2paths' | 'scope3paths'): void {
      (this.subdivisionForm.get(which) as FormArray).push(new FormControl(''));
    }
    removePathway(which: 'scope1paths' | 'scope2paths' | 'scope3paths', i: number): void {
      (this.subdivisionForm.get(which) as FormArray).removeAt(i);
    }

    // Multifamily scope filter, driven by scopedef.category (it used to guess
    // from the scope NAME). Checked = only Multifamily scopes; unchecked = every
    // active scope. Default resolved in resolveMfScopeDefault().
    showMultifamilyScopes = false;

    isMfScope(s: any): boolean {
      // Accepts either a scopedef row or a scope name (the saved
      // subdivision.scope is just the name, so it has to be looked up).
      const row = (s && typeof s === 'object')
        ? s
        : (this.scopes || []).find(x => x.scope === s);
      return !!row && (row.category || '').trim() === SCOPE_CATEGORY_MF;
    }

    get visibleScopes(): any[] {
      const all = this.scopes || [];
      if (!this.showMultifamilyScopes) { return all; }
      // Whatever is already saved on this subdivision stays in the list even if
      // it isn't Multifamily -- otherwise a mat-select whose value is filtered
      // out renders blank and reads as "the scope was lost".
      const selected = [
        this.subdivisionForm.get('scope') ? this.subdivisionForm.get('scope').value : null,
        this.subdivisionForm.get('scope2') ? this.subdivisionForm.get('scope2').value : null,
        this.subdivisionForm.get('scope3') ? this.subdivisionForm.get('scope3').value : null
      ].filter(v => !!v);
      return all.filter(s => this.isMfScope(s) || selected.indexOf(s.scope) >= 0);
    }

    // Opens on the MF list when the subdivision already carries a Multifamily
    // scope, else falls back to the subdivision's own MF flag. Called after the
    // scopes load, since the lookup needs their categories.
    private resolveMfScopeDefault(): void {
      const saved = [this.data.scope, this.data.scope2, this.data.scope3].filter(v => !!v);
      this.showMultifamilyScopes = saved.length > 0
        ? saved.some(v => this.isMfScope(v))
        : !!this.data.ismultifamily;
    }

    subs: any[] = [];

    // Subdivision fields that can be propagated to all existing locations when
    // changed. `control` is the form control / locmain column name, `label` is
    // shown in the confirmation popup. Add a new entry here (and to the backend
    // allowlist in subdivisions.js) to include another field in this system.
    readonly massUpdatableFields = [
      { control: 'city', label: 'City' },
      { control: 'region', label: 'Region' },
      { control: 'customer_id', label: 'Builder' },
    ];
    pendingMassUpdates: { control: string, label: string, value: any }[] = [];
    massUpdatePromptLabels = '';

    //used for tag modal
    currentAddedTagID = null;
    currentRemovedTagID
    currentAddedTagName = null;
    currentRemovedTagName = null;
    tagsToUpdate = [];
    tagsToRemove = [];


    consultants: Consultant[] = [

    ]


    regions: Region[] = [];
    states: State[] = _DROPDOWN_US_STATES


    checkACE(): void {
      if(this.subdivisionForm.get('cz').value == '3' && this.subdivisionForm.get('elecutility').value == 'DEC'){
          this.updateAce = true;
      }else {
        this.updateAce = false;
      }
    }

    clearContact(): void {
      this.subdivisionForm.get('contact_id').setValue(0);
      this.subdivisionForm.get('contact').setValue('');
      this.data.contact = '';
    }

    // Blanks out the city. Marked dirty (like onSelectCity) so save() picks it up
    // and offers the mass-update-to-locations prompt, since city is a
    // massUpdatableField.
    clearCity(): void {
      this.subdivisionForm.get('city').setValue('');
      this.subdivisionForm.get('city').markAsDirty();
      this.data.city = '';
    }

    updateClimateZone(): void {
      this.subdivisionService.getClimateZone(parseInt(this.subdivisionForm.get('dzip').value)).subscribe(
        res => {
          if(res && res.ClimateZone){
            this.subdivisionForm.get('cz').setValue(res.ClimateZone);
            this.rippleService.longRipple(this.defaultczRipple);
          }else {
            this.messager.openSnackBar('Error getting climate zone', '[close]', 'errorAlert');
          }
        }, err => {
        }
      );
    }


    save(): void {
      // Before saving, check whether any subdivision fields that locations
      // denormalize were changed. If so, prompt to backfill existing locations.
      // Only relevant when editing (mode 1); a new subdivision has no locations.
      if (this.mode === 1) {
        const dirty = this.massUpdatableFields.filter(f => this.subdivisionForm.get(f.control)?.dirty);
        if (dirty.length > 0) {
          this.pendingMassUpdates = dirty.map(f => ({ ...f, value: this.subdivisionForm.get(f.control).value }));
          this.massUpdatePromptLabels = dirty.map(f => f.label).join(', ');
          this.showMassUpdateModal();
          return; // wait for the user's response before saving
        }
      }
      this.proceedSave();
    }

    // Handles the "update existing locations?" popup. Optionally backfills the
    // changed fields onto all locations in the subdivision, then completes save.
    handleMassUpdateResponse(runUpdate: boolean): void {
      this.hideMassUpdateModal();

      if (runUpdate && this.pendingMassUpdates.length > 0) {
        const fields = {};
        this.pendingMassUpdates.forEach(f => fields[f.control] = f.value);

        this.subdivisionService.massUpdateLocations(this.data.subdivision_id, fields).subscribe(
          res => {
            if (res.Error) {
              this.messager.openSnackBar('Error updating existing locations: ' + res.Message, '[close]', 'errorAlert');
            } else {
              this.messager.openSnackBar(res.Message, '', 'successAlert');
              const updatedIds = (res.Updated_IDs || []).map(r => r.location_id);
              this.log.info(this.data.loggedIn + ' mass-updated locations for subdivision ' + this.data.subdivision_name + ' (id ' + this.data.subdivision_id + '): {' + this.massUpdatePromptLabels + '}; location IDs: [' + updatedIds.join(', ') + ']');
            }
            this.proceedSave();
          },
          err => {
            this.messager.openSnackBar('Error updating existing locations.', '[close]', 'errorAlert');
            this.log.error(this.data.loggedIn + ' encountered an error mass-updating locations for subdivision id ' + this.data.subdivision_id + ': ' + err.toString());
            this.proceedSave();
          }
        );
      } else {
        this.proceedSave();
      }
    }

    proceedSave(): void {
      const isArchived = !!this.subdivisionForm.get('archive')?.value;
      //see if builder field is empty, if so, do not allow save
      if(this.subdivisionForm.get('customer_id').value == 0 && !isArchived){
        this.messager.openSnackBar('Please select a builder', '[close]', 'errorAlert');
        return;
      }
  
      if(this.updateAce){

        this.subdivisionService.updateAceJobs(this.data.subdivision_id).subscribe(
          res => {
            this.messager.openSnackBar('ACE jobs updated', '[close]', 'successAlert')
          }, err => {
            this.messager.openSnackBar('Error updating ACE jobs', '[close]', 'errorAlert')
          });

          let thetag = {id: 12, displayname: 'ACE'};
          if (this.inputTags) {
            const tagIds = this.inputTags.map(existingTag => existingTag.id);
            if (!tagIds.includes(thetag.id)) {
              this.inputTags.push(thetag);
              this.log.info(this.data.loggedIn + ' added tag#' + thetag.id + ' (named: ' + thetag.displayname + ') to the subdivision:  ' + this.data.subdivision_name + 'with id:'  + this.data.subdivision_id );
            }
          }

          const tagIds = this.inputTags.map(tag => tag.id);
          this.subdivisionForm.get('tagControl').setValue(tagIds);

      }

      const tagIds = this.inputTags.map(tag => tag.id);
      this.subdivisionForm.get('tagControl').setValue(tagIds);


      if(this.tagsToRemove.length > 0){
        this.subdivisionService.removeTagsRetroactive(this.data.subdivision_id, this.tagsToRemove).subscribe(
          res => {
            if (res && res.Error) { this.messager.openSnackBar('Error removing tags from locations: ' + res.Message, '[close]', 'errorAlert'); }
          }, err => {
            this.messager.openSnackBar('Error removing tags from locations', '[close]', 'errorAlert');
          });
      }

      if(this.tagsToUpdate.length > 0){
        this.subdivisionService.updateTagsRetroactive(this.data.subdivision_id, this.tagsToUpdate).subscribe(
          res => {
            if (res && res.Error) { this.messager.openSnackBar('Error adding tags to locations: ' + res.Message, '[close]', 'errorAlert'); }
          }, err => {
            this.messager.openSnackBar('Error adding tags to locations', '[close]', 'errorAlert');
          });
      }

      //this.tagService.processTags(this.inputTags);

      //update Generator here
      let changedProperties = [];
          Object.keys(this.subdivisionForm.controls).forEach((name) => {
            const currentControl = this.subdivisionForm.controls[name];

            if (currentControl.dirty) {
              changedProperties.push(name +': ' + this.subdivisionForm.controls[name].value);
            }
      });
      if(this.subdivisionForm.get('subdivision_name').dirty){
        this.subdivisionService.updateAllSubdivisionNames(this.data.subdivision_id,this.subdivisionForm.get('subdivision_name').value).subscribe(
          res => {
          }, err => {
          }
        )
      }
      if(this.subdivisionForm.get('dzip').dirty){
        this.subdivisionService.updateAllZips(this.data.subdivision_id,this.subdivisionForm.get('dzip').value).subscribe(
          res => {
          }, err => {
          }
        )
      }
      let nopower = {id: 25, displayname: 'No Power'};
      if (this.inputTags) {
        const tagIds = this.inputTags.map(existingTag => existingTag.id);
        if (tagIds.includes(nopower.id)) {
          this.subdivisionForm.get('generator').setValue(true);
          this.log.info(this.data.loggedIn + ' added tag#' + nopower.id + ' (named: ' + nopower.displayname + ') to the subdivision:  ' + this.data.subdivision_name + 'with id:'  + this.data.subdivision_id );
        }
      }
      
      if(this.subdivisionForm.get('generator').dirty){
        this.subdivisionService.updateAllGenerator(this.data.subdivision_id).subscribe(
          res => {
          }, err => {
          }
        )
      }

      this.subdivisionService.saveEdit(this.data.subdivision_id, this.subdivisionForm.value).subscribe(
        (res) => {

          if(res.Error){

          //close the dialog
          this.dialogRef.close();
          let errMessage = res.Message;
          this.messager.openSnackBar('Error saving subdivision, an email with all data has been sent to support.', '[close]', 'errorAlert');

          this.ges.sendDebugEmail('IMPORTANT', this.subdivisionForm.value,'Subdivisions', errMessage).subscribe(
            res => {
              if(res.Error){
                this.log.error('Error sending debug email for subdivisions page: ' + res.Message)
              }else {
                this.log.debug('Debug email sent to support from the subdivisions page.')
              }
            }, err => {
              this.log.error('Application error sending debug email: ' + err.toString() );
            })

          this.log.error(this.data.loggedIn + ' encountered an error editing a plan: Submitted data: ' + '{' + this.subdivisionForm.value.toString() + '} ' + res.Message );


          }

          this.log.info(this.data.loggedIn + ' saved the following edits to subdivision ' + this.subdivisionForm.get('subdivision_name').value.trim() + ' {' + changedProperties.toString() + '}' );
          const synced = (res && Array.isArray(res.SyncedSubdivisionIds)) ? res.SyncedSubdivisionIds : [];
          if (synced.length > 0) {
            this.log.info(this.data.loggedIn + ' synced MF project tags from subdivision ' + this.data.subdivision_id + ' to ' + synced.join(','));
            // Sibling rows changed server-side; reload the grid so they show the new tags.
            this.subdivisionService.init();
          }
          this.dialogRef.close();
        },
        err => {
          this.log.error(this.data.loggedIn + ' encountered an error editing a subdivision: Submitted data: ' + '{' + this.subdivisionForm.value.toString() + '} ' + err.toString() );
        }
      );

    }

    displayFunctionEmployee(obj: any){
      if(obj) { return obj.employee_name}
    }
    
    add(): void {

      // check TRUE homes DEC/CZ3  here

      if(this.subdivisionForm.get('customer_id').value == 0){
        this.messager.openSnackBar('Please select a builder', '[close]', 'errorAlert');
        return;
      }

      if(this.subdivisionForm.get('cz').value?.trim() == '3' && this.subdivisionForm.get('elecutility').value?.trim() == 'DEC'){
        //push the ACE tag. Hard coded for now.
        let thetag = {id: 12, displayname: 'ACE'};
        if (this.inputTags) {
          const tagIds = this.inputTags.map(existingTag => existingTag.id);
          if (!tagIds.includes(thetag.id)) {
            this.inputTags.push(thetag);
            this.log.info(this.data.loggedIn + ' added tag#' + thetag.id + ' (named: ' + thetag.displayname + ') to the subdivision:  ' + this.data.subdivision_name + 'with id:'  + this.data.subdivision_id );
          }
        }

        const tagIds = this.inputTags.map(tag => tag.id);
        this.subdivisionForm.get('tagControl').setValue(tagIds);

        this.tagService.processTags(this.inputTags);
      }

      this.subdivisionService.addSubdivision(this.subdivisionForm.value).subscribe(
        res => {
          if(res.Error){

            let errMessage = res.Message;

            this.messager.openSnackBar('Error saving subdivision, an email with all data has been sent to support.', '[close]', 'errorAlert');

            this.ges.sendDebugEmail('IMPORTANT', this.subdivisionForm.value,'Subdivisions', errMessage).subscribe(
              res => {
                this.dialogRef.close();
                if(res.Error){
                  this.log.error('Error sending debug email for subdivisions page: ' + res.Message)
                }else {
                  this.log.debug('Debug email sent to support from the subdivisions page.')
                }
              }, err => {
                this.log.error('Application error sending debug email: ' + err.toString() );
              })

            this.log.error(this.data.loggedIn + ' encountered an error editing a plan: Submitted data: ' + '{' + this.subdivisionForm.value.toString() + '} ' + res.Message );

          }else{

          this.log.info(this.data.loggedIn + ' created subdivision ' + this.subdivisionForm.value.subdivision_name.trim() );
          this.dialogRef.close();
          }
        },
        err => {
          this.log.error(this.data.loggedIn + ' encountered an error creating a subdivision: Submitted data: ' + '{' + this.subdivisionForm.value.toString() + '} ' + err.toString() );
        }
      );
    }



    close(): void {
      this.dialogRef.close();
    }

    onSelectCustomer(customer: Customer): void {
      this.data.dhvaccontractor = customer.customer_id;
      this.subdivisionForm.get('dhvaccontractor').setValue(customer.customer_id);
      this.locationService.getHvacContractor(this.data.dhvaccontractor).subscribe(
        res => {
          this.hvacDisplay = res.customer_name;
        }, err => {
        }
      )
    }



    onSelectBuilder(customer: Customer): void {
      this.data.customer_id = customer.customer_id;
      this.data.customer_name = customer.customer_name;
      this.subdivisionForm.get('customer_id').setValue(customer.customer_id);
      this.subdivisionForm.get('customer_name').setValue(customer.customer_name);
    }

    onSelectContact(contact: Contact): void {
      this.data.contact_id = contact.id;
      this.data.contact = contact.name?.trim();
      this.subdivisionForm.get('contact_id').setValue(contact.id);
      this.subdivisionForm.get('contact').setValue(contact.name?.trim());
    }

    // `sub_id` holds a customers3.customer_id. 0 is the "+ Add a sub" sentinel (never a real id),
    // null is "-- None --". Keeps the denormalized sub_name control in sync with the selection.
    private setSub(sub_id: number, sub_name: string): void {
      this.data.sub_id = sub_id;
      this.data.sub_name = sub_name;
      this.subdivisionForm.get('sub_id').setValue(sub_id);
      this.subdivisionForm.get('sub_name').setValue(sub_name);
    }

    onSelectSub(selectedValue: number): void {

      if (selectedValue === 0) {

        // Remember what was selected so we can put it back if they bail out.
        const previousId = this.data.sub_id || null;
        const previousName = this.data.sub_name || '';

        const dialogRef = this.dialog.open(NewSubDialogComponent, {
          width: '400px',
        });

        dialogRef.afterClosed().subscribe(result => {

          if (!result) {
            this.setSub(previousId, previousName);
            return;
          }

          this.subdivisionService.addSub(result.name).subscribe(
            (res) => {
              if (res.Error) {
                this.setSub(previousId, previousName);
                this.messager.openSnackBar('Error saving new sub', '[close]', 'errorAlert');
                return;
              }

              // The backend hands back the existing row if the name is already on file.
              if (!this.subs.some(s => s.customer_id === res.Sub.customer_id)) {
                this.subs.push(res.Sub);
                this.subs.sort((a, b) => a.customer_name.localeCompare(b.customer_name));
              }

              this.setSub(res.Sub.customer_id, res.Sub.customer_name);
              this.messager.openSnackBar(`New sub '${res.Sub.customer_name}' added successfully`, '[close]', 'successAlert');
            },
            (err) => {
              this.setSub(previousId, previousName);
              this.messager.openSnackBar('Error saving new sub', '[close]', 'errorAlert');
            }
          );
        });

        return;
      }

      const sub = this.subs.find(s => s.customer_id === selectedValue);
      this.setSub(sub ? sub.customer_id : null, sub ? sub.customer_name : '');

    }

    // `control` says which scope select fired, so "++ New Scope ++" writes back to
    // the right FormControl.
    onSelectScope(selectedValue: string, control: 'scope' | 'scope2' | 'scope3' = 'scope'): void  {

      if (selectedValue === '0') {
        // Open the dialog to enter a new scope
        const dialogRef = this.dialog.open(NewScopeDialogComponent, {
          width: '400px',
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.subdivisionForm.get(control).setValue(result.scope);
            this.data[control] = result.scope;

            this.subdivisionService.saveNewScope(result).subscribe(
              (res) => {
                if (res && res.Error) {
                  this.messager.openSnackBar(res.Message || 'Error saving new scope', '[close]', 'errorAlert');
                  return;
                }
                // `category` must be carried onto the local row or the new scope
                // is invisible to the Multi-family filter until a page reload.
                this.scopes.push(
                  {
                    scope: result.scope,
                    category: result.category,
                    description: result.desc
                  }
                )
                this.messager.openSnackBar(`New scope '${result.scope}' added successfully`, '[close]', 'successAlert');
              },
              (err) => {
                this.messager.openSnackBar('Error saving new scope', '[close]', 'errorAlert');
              }
            );
          }
        });
      }

    }



    private _filter(value: string): any[] {
      const filterValue = value?.toLowerCase();
      return this.visibleTags.filter(tag => tag.displayname.toLowerCase().includes(filterValue));
    }



  ngOnInit() {

    // Auto-tick Billing Building when the name/MF controls change, never on open,
    // so a manual untick sticks.
    this.subdivisionForm.get('subdivision_name').valueChanges.subscribe(() => this.applyBillingBldgDefault());
    this.subdivisionForm.get('ismultifamily').valueChanges.subscribe(() => this.applyBillingBldgDefault());

    //load scopes
    this.subdivisionService.getScopes().subscribe(
      res => {
        this.scopes = res.Scopes;
        // Resolve the MF filter default only once the categories are on hand.
        this.resolveMfScopeDefault();
      });

    //load subs (customers3 rows typed as 'Sub')
    this.subdivisionService.getSubs().subscribe(
      res => {
        this.subs = res.Subs || [];
      });

      this.locationService.getHvacContractor(this.data.dhvaccontractor).subscribe(
        res => {
          this.hvacDisplay = res.customer_name;
        }, err => {
        }
      )

      this.cityService.getRegions().subscribe(
        data => this.regions = data
      )

    this.tagService.getTags().subscribe(
      res => {
        this.tags = res.data;
      });

    //load any tags that are already selected
    this.data.s_tags?.forEach(tag => {
      this.tagService.getTag(tag).subscribe(
        res => {
          this.inputTags.push(res.data);
        }
      );
    });

      this.filteredTags = this.subdivisionForm.get('tagControl').valueChanges.pipe(
        debounceTime(400),
        tap(value => {
        }),
        filter((tag: string | null) => tag && tag.length > 0),
        map((tag: string | null) => tag ? this._filter(tag) : this.tags.slice())
      );


      this.employee$ = this.subdivisionForm.get('consultant').valueChanges.pipe(
        debounceTime(400),
        tap(() => this.isLoading = true ),
        switchMap(value =>
          value.length > 0 ? this.locationService.getEmployeesDropdown(value as string) : empty()
          .pipe(
            tap((res) => {
              this.isLoading = false;
            }),
            finalize(() => this.isLoading = false)
            )
        )
      );


    this.locationService.getGasUtilities().subscribe(
      res => {
        this.gasUtilities = res.Data;
      }, err => {
        this.gasUtilities = [];
      });


      this.locationService.getElectricUtilities().subscribe(
        res => {
          this.elecUtilities = res.Data;
        }, err => {
          this.elecUtilities = [];
        });

    
    


    this.city$ = this.subdivisionForm.get('city').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.isLoading = true;
      }),
      switchMap(value =>
        value.length > 0 ? this.subdivisionService.getCitiesDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
        )
    );


      this.customer$ = this.subdivisionForm.get('dhvaccontractor').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.isLoading = true;
      }),
      switchMap(value =>
        value.length > 0 ? this.subdivisionService.getContractorDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
      )
    );

    this.builder$ = this.subdivisionForm.get('customer_id').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.isLoading = true;
      }),
      switchMap(value =>
        value.length > 0 ? this.contactService.getCustomersDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
      )
    );


    this.contact$ = this.subdivisionForm.get('contact').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.isLoading = true;
      }),
      switchMap(value =>
        value.length > 0 ? this.contactService.getContactsDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
      )
    );

        //get employee name:
        this.employeeService.getOneEmployee(this.data.consultant).subscribe(
          res => {
            this.employee_name = res.employee_name;
          }, err => {
          }
        );



  } //ngOn Init

  // A multi-family sub whose name says "billing" is the billing building. Auto-tick only.
  applyBillingBldgDefault(): void {
    const mf = !!this.subdivisionForm.get('ismultifamily').value;
    const name = String(this.subdivisionForm.get('subdivision_name').value || '');
    const ctrl = this.subdivisionForm.get('isbillingbldg');
    if (mf && /billing/i.test(name) && !ctrl.value) {
      ctrl.setValue(true);
      ctrl.markAsDirty();
    }
  }

  openMfContactsDialog(): void {
    if (!this.data.subdivision_id) { return; }
    const ref = this.dialog.open(MfContactsDialogComponent, {
      width: '960px',
      maxWidth: '95vw',
      data: {
        subdivision_id: this.data.subdivision_id,
        subdivision_name: this.subdivisionForm.get('subdivision_name').value,
        customer_id: Number(this.data.customer_id) || 0,
        customer_name: this.data.customer_name
      }
    });
    ref.afterClosed().subscribe(saved => {
      if (Array.isArray(saved)) { this.mfContactCount = saved.length; }
    });
  }

  showModal() : void {
    const modal = document.getElementById('tagModal');
    if(modal){
      modal.style.display = 'block';
    }
  }

  showMassUpdateModal() : void {
    const modal = document.getElementById('massUpdateModal');
    if(modal){
      modal.style.display = 'block';
    }
  }

  hideMassUpdateModal() : void {
    const modal = document.getElementById('massUpdateModal');
    if(modal){
      modal.style.display = 'none';
    }
  }

  showModalRemove() : void {
    const modal = document.getElementById('tagModalRemove');
    if(modal){
      modal.style.display = 'block';
    }
  }


  isMfProjectTag(id: number): boolean {
    return !!this.subdivisionForm.get('ismultifamily').value && MF_PROJECT_SYNC_TAG_IDS.includes(Number(id));
  }

  handleModalResponse(response : boolean) : void {
    const modal = document.getElementById('tagModal');
    if(modal){
      modal.style.display = 'none';
    }
    
    if(response){
      this.tagsToUpdate.push(this.currentAddedTagID);
      this.currentAddedTagID = null;
      this.currentAddedTagName = null;
      this.messager.openSnackBar('Tag will be added to previous locations on save.', '', 'successAlert');
    }else {
      this.currentAddedTagID = null;
      this.currentAddedTagName = null;
    }
  }

  handleModalResponseDelete(response : boolean) : void {
    const modal = document.getElementById('tagModalRemove');
    if(modal){
      modal.style.display = 'none';
    }
    
    if(response){
      this.tagsToRemove.push(this.currentRemovedTagID);
      this.currentRemovedTagID = null;
      this.currentRemovedTagName = null;
      this.messager.openSnackBar('Tag will be removed from previous locations on save.', '', 'successAlert');
    }else {
      this.currentRemovedTagID = null;
      this.currentRemovedTagName = null;
    }
  }

  addTag(event: MatChipInputEvent, tag?: any): void {

    const input = event.input;
    // Only add tag if it is not already selected
    if(tag){
      if (this.inputTags) {
        const tagIds = this.inputTags.map(existingTag => existingTag.id);
        if (!tagIds.includes(tag.id)) {
          this.inputTags.push(tag);
          this.currentAddedTagID = tag.id;
          this.currentAddedTagName = tag.displayname;
          this.log.info(this.data.loggedIn + ' added tag#' + tag.id + ' (named: ' + tag.displayname + ') to the subdivision:  ' + this.data.subdivision_name + 'with id:'  + this.data.subdivision_id );
          this.showModal();
        }
      }

    }

    if(this.tagsToRemove.includes(tag.id)){
      this.tagsToUpdate.splice(this.tagsToUpdate.indexOf(tag.id), 1);
      this.messager.openSnackBar("Tag will be removed from previous locations on save.", '', 'successAlert');
    }

    input.value = '';
  }

  onEnter(auto: MatAutocomplete): void {
    //if (!auto.optionSelected) {
      this.subdivisionForm.get('tagControl').setValue('');
    //}
  }

  removeTag(tag: any): void {
    const index = this.inputTags.indexOf(tag);

    if (index >= 0) {
      this.currentRemovedTagID = tag.id;
      this.currentRemovedTagName = tag.displayname;
      this.inputTags.splice(index, 1);
      this.log.info(this.data.loggedIn + ' removed tag#' + tag.id + ' (named: ' + tag.displayname + ') from the subdivision ' + this.data.subdivision_name + 'with id:  '+ this.data.subdivision_id);
      
      this.showModalRemove();
      if(this.tagsToUpdate.includes(tag.id)){
        this.tagsToUpdate.splice(this.tagsToUpdate.indexOf(tag.id), 1);
        this.messager.openSnackBar("Tag won't be added to previous locations on save.", '', 'successAlert');
      }

    }
  }


  resetEmployeeName(data){
    this.employee_name = '';
    this.data.consultant = 0;
  }

  onSelectEmployee(obj: any){
    this.employee_name = obj.employee_name;
    this.data.consultant = obj.employee_id;
    this.subdivisionForm.get('consultant').setValue(obj.employee_id);
  }


  onSelectCity(city: City): void {
    this.data.city = city.city;
    this.data.state = city.state;
    if(city.region){
      this.data.region = city.region?.trim();
      this.subdivisionForm.get('region').setValue(city.region?.trim());
      // setValue does not flag the control dirty; mark it so the save() mass-update
      // check (and any other dirty-tracking) picks up this programmatic change.
      this.subdivisionForm.get('region').markAsDirty();
      this.rippleService.basicRipple(this.regionRipple);
    }


    if(city.defaultcz){
      this.subdivisionForm.get('cz').setValue(city.defaultcz);
      this.rippleService.longRipple(this.defaultczRipple);
    }

    if(city.elevation){
      this.subdivisionForm.get('elevation').setValue(city.elevation);
      this.rippleService.longRipple(this.elevationRipple);
    }

    if(city.multiplecz){
      this.subdivisionForm.get('multiplecz').setValue(city.multiplecz);
    }



    this.subdivisionForm.get('city').setValue(city.city);
    this.subdivisionForm.get('city').markAsDirty();
    this.rippleService.longRipple(this.cityRipple);
    this.subdivisionForm.get('state').setValue(city.state);
    this.subdivisionForm.get('state').markAsDirty();
    this.rippleService.longRipple(this.stateRipple);



  }

  displayFunction(city: City): string{
    if (city) {
      return city.lister;
    }
}

displayFunctionContractor(customer: Customer){
  if (customer) { return customer.customer_name; }
}

displayFunctionBuilder(customer: Customer){
  if (customer) { return customer.customer_name; }
}

displayFunctionContact(contact: Contact){
  if (contact) { return contact.name; } 
}





}



@Component({
  selector: 'app-subdivisions',
  templateUrl: './subdivisions.component.html',
  styleUrls: ['./subdivisions.component.css']
})
export class SubdivisionsComponent implements OnInit {

  // tslint:disable-next-line: variable-name
  subdivision_id: number;
  // tslint:disable-next-line: variable-name
  subdivision_name: string;
  city: string;
  state: string;
  cz: string;
  gps: string;
  inactivesubdivision: boolean;
  dzip: string;
  lat: string;
  lng: string;
  dhvaccontractor: number;
  region: string;
  ratercompid: number;
  jurisdictionid: number;
  weatherloc: string;
  scope: string;
  elevation: number;
  priceadder: number;
  municipality: string;
  areamanager: string;
  areamanemail: string;
  archive: boolean;
  gasutility: string;
  elecutility: string;
  generator: boolean;
  consultant: number;
  contact_id: number;


  public configuration: Config;
  public columns: Columns[];
  editData;

  modal = false;
  selected;
  user;
  usernamee;
  socket: any;

  faedit = faEdit;
  facopy = faCopy;
  fatrash = faTrashAlt;
  gridEntrie$: Observable<Subdivision[]>;
  displayedColumns: string[] = ['subdivision_name', 'city', 'state', 'region'];

  regions: Region[] = [
    {value: 'ASH', viewValue: 'ASH'},
    {value: 'ATL', viewValue: 'ATL'},
    {value: 'AUG', viewValue: 'AUG'},
    {value: 'CHS', viewValue: 'CHS'},
    {value: 'CLT', viewValue: 'CLT'},
    {value: 'COL', viewValue: 'COL'},
    {value: 'CSTL', viewValue: 'CSTL'},
    {value: 'GRV', viewValue: 'GRV'},
    {value: 'KNX', viewValue: 'KNX'},
    {value: 'LOU', viewValue: 'LOU'},
    {value: 'MEM', viewValue: 'MEM'},
    {value: 'MF', viewValue: 'MF'},
    { value: "NOOG", viewValue: "NOOG" },
    {value: 'NSH', viewValue: 'NSH'},
    {value: 'RDU', viewValue: 'RDU'},
    {value: 'RIC', viewValue: 'RIC'},
    {value: 'TRI', viewValue: 'TRI'}
  ];

  constructor(public subdivisionService: SubdivisionService, public dialog: MatDialog, private auth: AuthService, private log: LoggingService, private messager: MessagerComponent) {

    //this.socket = io('https://raterhelperv3.herokuapp.com');
    this.socket = io(environment.baseUrl);

   }

  openDialog(myData, selectedMode): void {


    this.subdivisionService.getOneSubdivision(myData.subdivision_id).subscribe(

      res => {
        const dialogRef = this.dialog.open(EditSubdivisionDialogComponent, {
          width: '600px',
          data: {
            subdivision_id: res.Subdivision.subdivision_id,
            subdivision_name: res.Subdivision.subdivision_name,
            contact_id: res.Subdivision.contact_id,
            city: res.Subdivision.city,
            state: res.Subdivision.state,
            cz: res.Subdivision.cz,
            gps: res.Subdivision.gps,
            inactivesubdivision: res.Subdivision.inactivesubdivision,
            dzip: res.Subdivision.dzip,
            lat: res.Subdivision.lat,
            lng: res.Subdivision.lng,
            dhvaccontractor: res.Subdivision.dhvaccontractor,
            region: res.Subdivision.region?.trim(),
            ratercompid: res.Subdivision.ratercompid,
            jurisdictionid: res.Subdivision.jurisdictionid,
            weatherloc: res.Subdivision.weatherloc,
            scope: res.Subdivision.scope,
            // Second and third informational scopes + the pathways under each (many per scope).
            scope2: res.Subdivision.scope2,
            scope3: res.Subdivision.scope3,
            scope1paths: res.Subdivision.scope1paths || [],
            scope2paths: res.Subdivision.scope2paths || [],
            scope3paths: res.Subdivision.scope3paths || [],
            elevation: res.Subdivision.elevation,
            priceadder: res.Subdivision.priceadderk,
            municipality: res.Subdivision.municipality,
            areamanager: res.Subdivision.areamanager,
            areamanemail: res.Subdivision.areamanemail,
            archive: res.Subdivision.archive,
            gasutility: res.Subdivision.gasutility,
            elecutility: res.Subdivision.elecutility,
            customer_name: res.Subdivision.customer_name,
            customer_id : res.Subdivision.customer_id,
            sub_id : res.Subdivision.sub_id,
            sub_name : res.Subdivision.sub_name,
            overridesc : res.Subdivision.overridesc,
            townhomes : res.Subdivision.townhomes,
            generator : res.Subdivision.generator,
            mode: selectedMode,
            loggedIn : this.usernamee,
            s_tags : res.Subdivision.s_tags,
            consultant : res.Subdivision.consultant,
            contact : res.Subdivision.contact,
            updateall : res.Subdivision.updateall,
            bldr_region : res.Subdivision.bldr_region,
            ismultifamily : res.Subdivision.ismultifamily,
            num_units : res.Subdivision.num_units,
            story_type : res.Subdivision.story_type,
            stickerlocation : res.Subdivision.stickerlocation,
            envspecs : res.Subdivision.envspecs,
            isbillingbldg : res.Subdivision.isbillingbldg,
            mf_contacts : res.Subdivision.mf_contacts || []
          },
          panelClass: 'edit-dialog-container'
        });
    
        dialogRef.afterClosed().subscribe(result => {
          this.editData = result;
        });

      }


    );
  }

  copySubdivision(row): void {
    this.subdivisionService.copySubdivision(row.subdivision_id).subscribe(
      res => {
        this.subdivisionService.addOneFrontend(res.Sub);
        this.messager.openSnackBar('Subdivision copied!', '[close]', 'successAlert');
      });
  }





  ngOnInit(): void {

    this.subdivisionService.init();

    this.auth.userProfile$.subscribe(
      (profile) => {
        this.user = profile;
        this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
    });

    this.configuration = {...DefaultConfig};
    this.configuration.tableLayout.theme = 'lIGHT';
    this.configuration.tableLayout.style = 'big';
    this.configuration.tableLayout.borderless = false;
    this.configuration.tableLayout.hover = true;
    this.configuration.searchEnabled = true;
    this.configuration.paginationEnabled = true;
    this.configuration.paginationRangeEnabled = false;
    this.configuration.isLoading = true;
    this.configuration.rows = 100;

    this.gridEntrie$ = this.subdivisionService.getInitial().pipe(
      tap(() => {
        this.configuration.isLoading = this.subdivisionService.isLoading;
      })
    );

    this.columns = [
      // NOTE: the grid body is a custom ng-template whose <td>s map to these
      // columns POSITIONALLY. Any entry added here needs a matching <td> in
      // subdivisions.component.html or every later column shifts left.
      { key: 'subdivision_name', title: 'Name' },
      { key: 'scope', title: 'Scope' },
      { key: 'scope2', title: 'Scope 2' },
      { key: 'scope3', title: 'Scope 3' },
      { key: 'city', title: 'City' },
      { key: 'state', title: 'State' },
      { key: 'region', title: 'Region'},
      { key: 'cz', title: 'Climate Zone'},
      { key: 'customer_name', title: 'Builder' }
    ];

    this.socket.on('newSubdivision', data => {
      this.subdivisionService.addOneFrontend(data.newOne);
    });

  }

  addSubdivisionDialog(): void {
    const dialogRef = this.dialog.open(EditSubdivisionDialogComponent, {
      width: '600px',
      data: {
        mode: 2,
        loggedIn : this.usernamee
      },
      panelClass: 'edit-dialog-container'
    });

  }


  deleteSubdivision(object: Subdivision): void {
    const dialogRef = this.dialog.open(GridDeleteComponent, {
      width: '500px',
      data: {
        delete_body_text: 'Are you sure you want to delete ' + object.subdivision_name + '?',
        delete_api_url: '/rhAPI/subdivisions/delete/',
        delete_id: object.subdivision_id,
        delete_header_text: 'Deleting ' + object.subdivision_name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.subdivisionService.deleteSubdivision(object.subdivision_id);
        this.log.info(this.usernamee + ' deleted the subdivision: ' + object.subdivision_name + ' id: ' + object.subdivision_id);
      }
    });

  }

}

@Component({
  selector: 'app-new-sub-dialog',
  template: `
    <h1 mat-dialog-title>Enter New Sub</h1>
    <div mat-dialog-content>
      <form [formGroup]="subForm">
        <mat-form-field style="width:100%">
          <mat-label>Sub Name</mat-label>
          <input matInput placeholder="Enter sub name" formControlName="subName" />
          <mat-error *ngIf="subForm.get('subName').invalid">Sub name is required</mat-error>
        </mat-form-field>
      </form>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-button [disabled]="subForm.invalid" (click)="onConfirm()">Confirm</button>
    </div>
  `
})
export class NewSubDialogComponent {
  subForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<NewSubDialogComponent>,
    private fb: FormBuilder
  ) {
    this.subForm = this.fb.group({
      subName: ['', Validators.required]
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.subForm.valid) {
      this.dialogRef.close({
        name: this.subForm.get('subName').value
      });
    }
  }
}

@Component({
  selector: 'app-new-scope-dialog',
  template: `
    <h1 mat-dialog-title>Enter New Scope</h1>
    <div mat-dialog-content>
      <form [formGroup]="scopeForm">
        <mat-form-field style="width:100%">
          <mat-label>New Scope</mat-label>
          <input matInput placeholder="Enter scope name" formControlName="scopeName" />
          <mat-error *ngIf="scopeForm.get('scopeName').invalid">Scope name is required</mat-error>
        </mat-form-field>


        
      <!-- Category is REQUIRED: it drives the Multi-family scope filter on the
           subdivision dialog, so a scope saved without one could never be found
           by that filter. Same layout as the Description field below it. -->
      <mat-form-field style="width:100%; margin-top: 2em;">
        <mat-label>Category</mat-label>
        <mat-select formControlName="scopeCategory">
          <mat-option *ngFor="let c of categories" [value]="c">{{c}}</mat-option>
        </mat-select>
        <mat-error *ngIf="scopeForm.get('scopeCategory').invalid">Category is required</mat-error>
      </mat-form-field>

      <mat-form-field style="width:100%; margin-top: 2em;">
        <mat-label>Description (Optional)</mat-label>
        <textarea matInput placeholder="Enter scope name (optional)" formControlName="scopeDesc"></textarea>
      </mat-form-field>

      </form>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-button [disabled]="scopeForm.invalid" (click)="onConfirm()">Confirm</button>
    </div>
  `
})
export class NewScopeDialogComponent {
  scopeForm: FormGroup;
  categories: string[] = SCOPE_CATEGORIES;

  constructor(
    public dialogRef: MatDialogRef<NewScopeDialogComponent>,
    private fb: FormBuilder
  ) {
    this.scopeForm = this.fb.group({
      scopeName: ['', Validators.required],
      scopeCategory: ['', Validators.required],
      scopeDesc: ['']
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.scopeForm.valid) {
      this.dialogRef.close({
        scope: this.scopeForm.get('scopeName').value,
        category: this.scopeForm.get('scopeCategory').value,
        desc: this.scopeForm.get('scopeDesc').value
      });
    }
  }
}

